<div class="ui-dialog">
    <h3 class="ui-dialog-title ui-title" mat-dialog-title>Enviar factura por email</h3>
    
    <div class="ui-dialog-content" mat-dialog-content>
        <p>Enviaremos una copia de la factura <strong>{{data.invoice.receipt}}</strong> a todas las direcciones de correo que se encuentran asociadas a tu cuenta.</p>
    </div>
    
    <div class="ui-dialog-actions" mat-dialog-actions>
        <button mat-button type="button" (click)="onCancel()">Cancelar</button>
        <button mat-button type="button" color="primary" class="ui-button" (click)="onSend()">Enviar</button>
    </div>
    
    <!--<form [formGroup]="invoiceEmailSendFG" (ngSubmit)="onInvoiceEmailSend()">
        <h3 class="ui-dialog-title ui-title" mat-dialog-title>Enviar factura por email</h3>
    
        <div class="ui-dialog-content" mat-dialog-content>
            <p>Ingresa una dirección de correo. Enviaremos allí la factura seleccionada.</p>
            
            <div class="ui-form">
                <div class="ui-form-row">
                    <mat-form-field class="ui-input">
                        <mat-label>Email</mat-label>
                        <input matInput type="email" formControlName="email">
                        <mat-error *ngIf="invoiceEmailSendHasError('email','required')">Ingrese el email</mat-error>
                        <mat-error *ngIf="invoiceEmailSendHasError('email','email')">El formato de email es incorrecto</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
    
        <div class="ui-dialog-actions" mat-dialog-actions>
            <button mat-button type="button" (click)="onCancel()">Cancelar</button>
            <button mat-button type="submit" color="primary" class="ui-button" *ngIf="!request">Enviar</button>
            <mat-spinner class="ui-spinner" [diameter]="36" *ngIf="request"></mat-spinner>
        </div>
    </form>-->
</div>